import React from 'react'
import styled from 'styled-components'
import Arrow from '@icons/stepArrow.inline.svg'
import Box from '@components/Box'
import { STypographyParagraph } from '@components/Typography'

export interface IStep {
  heading: React.ReactNode
  content?: React.ReactNode
}

export interface ISteps {
  steps: IStep[]
  color?: string
}

export const SStep = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
`

const SSteps = styled.div`
  display: flex;
  justify-content: space-between;

  ${SStep} {
    width: 400px;
    margin-right: 40px;
    &:first-child {
      width: 380px;
    }
    &:last-child {
      width: 310px;
      margin-right: 0;
    }
  }
`

interface IColor {
  color?: string
}

export const SNumber = styled.div<IColor>`
  font-size: 90px;
  line-height: 90px;
  width: 52px;
  margin-right: 40px;
  color: ${({ theme, color }) => color || theme.colors.green};
`

const SWrap = styled.div`
  overflow-x: auto;
  width: 100%;
  padding-bottom: 20px;
`

const Steps: React.FC<ISteps> = ({ steps, color }) => {
  return (
    <SWrap>
      <SSteps>
        {steps.map(({ heading, content }, i) => (
          <SStep key={i}>
            <Box display="flex" alignItems="center" mb="12px">
              <SNumber color={color}>{i + 1}</SNumber>
              {i !== steps.length - 1 && <Arrow />}
            </Box>
            <STypographyParagraph mb="12px" fontWeight="600">
              {heading}
            </STypographyParagraph>
            {content}
          </SStep>
        ))}
      </SSteps>
    </SWrap>
  )
}

export default Steps
